(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adorn-account-login"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const dialog = document.getElementById('AdornAccountLogin');
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      let opener;
      const close = () => { if (dialog.open) dialog.close(); };
      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target instanceof Element ? event.target.closest('a.adorn-adv-account, a[data-adorn-account-open]') : null;
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        event.preventDefault();
        if (dialog.open) return;
        opener = link;
        dialog.showModal();
        document.documentElement.classList.add('adorn-account-open');
        const continuation = dialog.querySelector('[data-adorn-account-continue]');
        if (continuation) continuation.focus({ preventScroll: true });
      });
      dialog.querySelector('[data-adorn-account-close]').addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const items = Array.from(dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter((item) => !item.disabled && item.tabIndex >= 0 && item.getClientRects().length);
        const first = items[0];
        const last = items[items.length - 1];
        if (!first) return;
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('adorn-account-open');
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      });
      window.addEventListener('pagehide', close);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
